import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login-register',
  templateUrl: './loginregisterparams.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginRegisterComponentParams {

  email: string = '';
  name: string = '';
  last_name: string = '';
  errorMessage: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const emailParam = this.route.snapshot.queryParamMap.get('email');

    if (emailParam) {
      this.email = emailParam;
      console.log("Email recibido:", emailParam);
    }
    const nameParam = this.route.snapshot.queryParamMap.get('name');
    if (nameParam) {
      this.name = nameParam;
      console.log("Name recibido:", nameParam);
    }
    const lastNameParam = this.route.snapshot.queryParamMap.get('last_name');
    if (lastNameParam) {
      this.last_name = lastNameParam;
      console.log("Last name recibido:", lastNameParam);
    }
    this.login();
  }

  async login() {

    console.log("Entrando a async")
    try {
      const response = await fetch('https://api.calobesidad.innsider.com.co/api/login-register-params/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.email,
          name: this.name,
          last_name: this.last_name,
        })
      });

      if (!response.ok) throw new Error('Error en la solicitud');

      const data = await response.json();

      if (data.access) {
        localStorage.setItem('access_token', data.access_token);
        this.router.navigate(['/home']);
      } else {
        this.errorMessage = 'Login fallido.';
      }

    } catch (error) {
      this.errorMessage = 'Credenciales inválidas.';
    }
  }
}
